import React from "react";
import { Shield } from "lucide-react";

/**
 * Tab Header Component
 * Displays tabs for Scanner and Activity Logs
 */
export const TabHeader = ({ activeTab, setActiveTab }) => {
  return (
    <div className="flex items-center gap-1 border-b border-gray-200 pb-0">
      <button
        onClick={() => setActiveTab("scanner")}
        className={`flex items-center gap-2 px-5 py-3 text-sm font-medium border-b-2 transition-all -mb-px ${activeTab === "scanner"
          ? "border-purple-600 text-purple-700"
          : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
          }`}
      >
        <Shield className="w-4 h-4" />
        PII Scanner
      </button>
      <button
        onClick={() => setActiveTab("logs")}
        className={`flex items-center gap-2 px-5 py-3 text-sm font-medium border-b-2 transition-all -mb-px ${activeTab === "logs"
          ? "border-purple-600 text-purple-700"
          : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
          }`}
      >
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
          />
        </svg>
        Activity Logs
      </button>
    </div>
  );
};
